
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
if (this.$route.params.ItemVersion.CPV_Date !== '') {
this.list = [{
label: '检验检疫类别名称',
value: this.$route.params.Item.PRD_Name
}, {
label: '检验检疫类别说明',
value: this.$route.params.Item.PRD_Remark
}]
} else {
this.list = [{
label: '检验检疫类别名称',
value: this.$route.params.Item.PRD_Name
}, {
label: '检验检疫类别说明',
value: this.$route.params.Item.PRD_Remark
}]
}
}
}



// WEBPACK FOOTER //
// ./src/components/P_CIQDocDetail.vue